var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.logined)?_c('Login',{on:{"exit":function($event){_vm.logined = true}}}):_c('AdminScreen')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }